function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M271.6,76C255.2,76,242,62.4,242,46.4V0H60c-5.6,0-10.4,4.8-10.4,10.4v346.4c0,5.6,4.8,10.4,10.4,10.4h247.6 c5.6,0,10-4.8,10-10.4V76H271.6z M136,185.2c-4.4,4-10.8,5.6-20,5.6h-13.2v20.4c0,12-14.4,12-14.4,0V156c0-6.4,2.8-8.8,9.2-8.8 c8,0,24.8-0.4,31.2,1.2C146.4,153.2,146.4,176.8,136,185.2z M215.2,194.4c-2.4,12.4-10.4,21.6-23.2,23.6l-27.6,0.8 c-7.6,0-9.2-3.2-9.2-10.4V156c0-6.4,2.8-8.8,8.8-8.8c8.8,0,24-0.8,31.6,1.2C214,153.2,219.2,176.4,215.2,194.4z M276.8,156.8 c-1.2,1.2-2.8,1.6-5.2,1.6h-28.4v18.4h24c8.8,0,8.8,10.8,0,10.8h-24v23.6c0,10.4-9.2,10.4-12.4,6.8c-1.2-1.6-2-4-2-6.8V156 c0-6.4,2.8-8.8,8.8-8.8h34C279.6,147.2,279.6,154.4,276.8,156.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.8,158h-9.6v22h-0.4c10.4,0,25.6,2,25.6-11.2C128.4,160,122.4,158,112.8,158z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.2,159.2h-9.6v48.4c6,0,16,0.4,20.8-1.2c13.6-4.8,12.8-31.2,8-39.2C194,160,187.6,159.2,179.2,159.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.6,58.4h33.6l-46-46V46C259.2,53.2,264.8,58.4,271.6,58.4z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 367.2 367.2",
    style: {
      enableBackground: "new 0 0 367.2 367.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.d4415104.svg";
export { ForwardRef as ReactComponent };